import { render, staticRenderFns } from "./ContactsSidebar.vue?vue&type=template&id=846ca8b2&scoped=true"
import script from "./ContactsSidebar.vue?vue&type=script&lang=js"
export * from "./ContactsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ContactsSidebar.vue?vue&type=style&index=0&id=846ca8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846ca8b2",
  null
  
)

export default component.exports